import { Injectable } from '@angular/core';
import { toObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ChallengeActivityQuestionAttemptQuery,
  ChallengeActivityQuestionAttemptService,
  ChallengeActivityQuestionAttemptStatus,
} from '@examdojo/challenge';
import { isNotNullish } from '@examdojo/core/util/nullish';
import { McqSelectionService } from '@examdojo/question';
import {
  debounceTime,
  distinctUntilChanged,
  distinctUntilKeyChanged,
  filter,
  merge,
  Observable,
  pairwise,
  switchMap,
} from 'rxjs';
import { QuestionSubmitReadyService } from '../../../question-v2/question-submit-ready';

@Injectable()
export class ChallengeActivityQuestionStatusEffect {
  constructor(
    private readonly challengeActivityQuestionAttemptQuery: ChallengeActivityQuestionAttemptQuery,
    private readonly challengeActivityQuestionAttemptService: ChallengeActivityQuestionAttemptService,
    private readonly mcqSelectionService: McqSelectionService,
    private readonly questionSubmitReadyService: QuestionSubmitReadyService,
  ) {
    merge(
      this.handleStatusTransition(toObservable(this.mcqSelectionService.hasSomeChoiceOptionSelected), 'DONE'),
      this.handleStatusTransition(toObservable(this.questionSubmitReadyService.isSubmitReady), 'IN_PROGRESS'),
    )
      .pipe(takeUntilDestroyed())
      .subscribe();
  }

  private handleStatusTransition(
    statusChangeTrigger$: Observable<boolean>,
    targetStatus: ChallengeActivityQuestionAttemptStatus,
  ) {
    return this.challengeActivityQuestionAttemptQuery.selectActive().pipe(
      filter(isNotNullish),
      distinctUntilKeyChanged('id'),
      switchMap((attempt) =>
        statusChangeTrigger$.pipe(
          debounceTime(500),
          distinctUntilChanged(),
          pairwise(),
          filter(([prev, curr]) => !prev && curr),
          filter(() => attempt.status === 'TODO'),
          switchMap(() =>
            this.challengeActivityQuestionAttemptService.updateQuestionAttemptStatus(
              targetStatus,
              attempt.question_id,
              attempt.challenge_activity_id,
            ),
          ),
        ),
      ),
    );
  }
}
